module.exports = __webpack_public_path__ + "img/wav.63035b4a.svg";